<template>
    <b-modal id="qr-password-modal" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
        :body-class="'equipment-edit-modal'" no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('driverQRPassword.title') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="body">
            <b-row>
                <b-col sm="12" class="text-left mt-3">
                    <label>{{ $t('driverQRPassword.generateWithPassword') }}</label>
                    <b-form-checkbox name="check-button" class="ml-0-6rem" v-model="generateWithPassword" switch
                        size="lg"></b-form-checkbox>
                </b-col>
                <b-col cols="12" class="mt-3" v-if="generateWithPassword">
                    <b-form-group :label="$t('driverQRPassword.passwordLabel')" class="text-left mb-0 password show-password-section">
                        <b-form-input v-model="password" :placeholder="$t('driverQRPassword.passwordPlaceholder')" class="unit"
                            :type="showPassword ? 'text' : 'password'" required></b-form-input>

                        <b-icon :icon="showPassword ? 'eye-fill' : 'eye-slash-fill'"
                            @click="showPassword = !showPassword"></b-icon>
                        <p v-if="errors && errors.password" class="field-error mb-lg-3">
                            {{ errors.password[0] }}
                        </p>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                <b-button class="mx-0 mr-3 h-40px w-100px m-0" @click="resetForm()" variant="secondary">{{ $t('driverQRPassword.cancel') }}</b-button>
                <div class="d-flex align-items m-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                        @click="sendInvite()">{{ $t('driverQRPassword.generate') }}</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
export default {
    name: "DriverQRPassword",
    data() {
        return {
            showPassword: false,
            generateWithPassword: false,
            password: "",
            errors: {

            }
        }
    },
    methods: {
        resetForm() {
            this.password = "",
                this.errors = {}
            this.$bvModal.hide('qr-password-modal')
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        sendInvite() {
            try {
                let nullKeys = [];
                if (this.generateWithPassword) {
                    nullKeys = this.checkNullValues({
                        password: this.password
                    })
                }
                if (nullKeys.length === 0) {
                    this.$emit("generateQRCode", this.generateWithPassword ? this.password : null)
                    this.errors = {};
                    this.generateWithPassword = false;
                    this.password = "";
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('driverQRPassword.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        }
    },
}
</script>